import React, { useEffect } from "react";

import styled from "styled-components/macro";

import API from "UserProfile/Family/API";

import { FnrOverlayTitle } from "UI/FnrOverlay";
import { SharedResizingChild } from "UI/SharedResizingArea";

export default function ConflictsConfirmation({
  conflicts = [],
  userFname,
  gender,
  isSelf = false,
  saveData,
  loading,
  setLoading,
  shouldSave,
  setShouldSave,
  handleRelationshipResponse,
}) {
  const getGender = (neutral) => {
    if (!gender) return neutral;

    return gender.toLowerCase() === "male" ? "his" : "her";
  };

  useEffect(() => {
    if (!shouldSave || loading) return;

    setLoading(true);

    saveData.ignoreConflicts = true;

    const saveCall = API.saveRelationship(saveData);

    saveCall
      .post()
      .then((resp) => {
        setLoading(false);
        setShouldSave(false);
        handleRelationshipResponse(resp);
      })
      .catch((err) => {
        //console.log(err);
      });

    return () => saveCall.cancel();

    // Aug 2021 → we’re doing a clean slate of all warnings and ain’t got time to look at this so that’s why this is disabled
    // eslint-disable-next-line
  }, [shouldSave]);

  return (
    <SharedResizingChild>
      <FnrOverlayTitle>Just to confirm some things...</FnrOverlayTitle>
      {conflicts.includes("in_household") && (
        <ConflictLine>
          <Icon className="fas fa-house-user" />
          <Text>
            {isSelf ? "You are " : userFname + " is "}
            already a part of another household. This will remove{" "}
            {isSelf ? "you" : "them"} from {isSelf ? "your" : "their"} current
            household.
          </Text>
        </ConflictLine>
      )}
      {conflicts.includes("transfer_giving_data") && (
        <ConflictLine>
          <Icon className="fas fa-money-check-alt" />
          <Text>
            {isSelf ? "You have " : userFname + " has "}
            giving data on file. This will move{" "}
            {isSelf ? "your" : getGender("their")} giving data into this
            household.
          </Text>
        </ConflictLine>
      )}
      {conflicts.includes("remove_relationships") && (
        <ConflictLine>
          <Icon className="fas fa-site-map" />
          <Text>
            This is in conflict with some of{" "}
            {isSelf ? "your" : userFname + "'s"} other relationships in the
            household. You can adjust this on the next screen.
          </Text>
        </ConflictLine>
      )}
    </SharedResizingChild>
  );
}

const ConflictLine = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  max-width: 440px;
`;
const Icon = styled.div`
  font-size: 24px;
  margin-right: 12px;
`;
const Text = styled.div``;
